module.exports = __webpack_public_path__ + "static/keyword_2-8fc54fdddc4c08a715fae30faae9360b.jpg";